import type {
  shippingMethodBodyRequest,
  ShippingMethodRepository
} from '../domain/ShippingMethodRepository';

export const getGeneralShippingMethods = async (
  repository: ShippingMethodRepository,
  params?: shippingMethodBodyRequest[]
) => {
  return repository.getGeneralShippingMethods(params);
};
